var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTangibleResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.12 1.929-10.891 5.576-4.329-2.13 10.699-5.283c.24-.122.528-.122.78 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.088 5.375-11.082 5.49-4.15-2.045-.6-.305 10.903-5.575.6.304z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.118 12.447-.012 11.553-10.614-5.539c-.3-.158-.492-.475-.492-.816v-10.688l4.498 2.216v3.896c0 .499.408.913.9.913s.9-.414.9-.913v-2.995l.6.292z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m23.988 6.969-11.07 5.466-.012 11.553 11.094-5.793z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTangibleResource);
export default __webpack_public_path__ + "static/media/tangible-resource.bf70b10bd08a52237de3ae3d7d747458.svg";
export { ForwardRef as ReactComponent };